/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components

import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CustomTabs from 'components/CustomTabs/CustomTabs.jsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TransactionStyle from 'assets/jss/material-dashboard-pro-react/views/TransactionStyle';
import AthHistory from './ReceivableAthHistory';
import BthHistory from './ReceivableBthHistory';
import { switchActivePage } from '../../../reducers/transactions';
import apiCaller from '../../../utils/apiCallerOutstanding';
import firebase from '../../../config/config';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping';
import logger from '../../../utils/logger';

const canViewOnAccount = activeRole =>
  activeRole === 'finance' || activeRole === 'finance-recievable';

class ReceivableHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onAccount: null,
    };
    this.hideDetailedForm = this.hideDetailedForm.bind(this);
    this.fetchOnAccount = this.fetchOnAccount.bind(this);
  }

  componentDidMount() {
    this.fetchOnAccount();
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.currentTransactionData?.transactionId;
    const nextId = this.props.currentTransactionData?.transactionId;
    if (
      prevId !== nextId ||
      prevProps.activeRole !== this.props.activeRole
    ) {
      this.setState({ onAccount: null }, () => this.fetchOnAccount());
    }
  }

  async fetchOnAccount() {
    const { activeRole, currentTransactionData } = this.props;
    const transactionId = currentTransactionData?.transactionId;
    if (!canViewOnAccount(activeRole)) {
      return;
    }
    if (!transactionId) {
      this.setState({ onAccount: '' });
      return;
    }

    const user = firebase.auth().currentUser;
    if (!user) {
      this.setState({ onAccount: '' });
      return;
    }
    const { Aa: token } = user;
    const role = mappedCurrentActiveRole(activeRole);
    const endPoint = `transactions/v1/transporter-on-account?role=${role}&transaction_id=${transactionId}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const onAccount = response?.data?.data?.on_account;
      if (onAccount === undefined || onAccount === null || onAccount === '') {
        this.setState({ onAccount: '' });
        return;
      }
      this.setState({ onAccount });
    } catch (e) {
      logger.error('Error fetching transporter on account', e);
      this.setState({ onAccount: '' });
    }
  }

  hideDetailedForm() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.switchActivePage(false);
  }

  /**
   * Will return the Tabs ATH and BTH
   * @function
   */
  // eslint-disable-next-line class-methods-use-this
  getTabs() {
    return (
      <CustomTabs
        headerColor="#fff"
        tabs={[
          {
            tabName: 'ATH',
            tabContent: (
              <AthHistory
                currentTransactionData={this.props.currentTransactionData}
                onReceivableAdded={this.fetchOnAccount}
              />
            ),
          },
          {
            tabName: 'BTH',
            tabContent: (
              <BthHistory
                currentTransactionData={this.props.currentTransactionData}
                onReceivableAdded={this.fetchOnAccount}
              />
            ),
          },
        ]}
      />
    );
  }

  render() {
    const { classes, currentReceivableAmount, activeRole } = this.props;
    const { onAccount } = this.state;
    const showOnAccount = canViewOnAccount(activeRole) && onAccount !== null;
    const hasOnAccountAmount = onAccount !== '' && onAccount != null;
    return (
      <Card>
        <CardHeader
          className={`${classes.cardHeader}`}
          style={{
            marginBottom: '1px',
            paddingBottom: '1px',
            paddingTop: '1px',
          }}
        >
          <h3 className={classes.cardTitle}>
            Receivable:{' '}
            <i
              className="fa fa-inr"
              style={{ fontSize: '22px' }}
              aria-hidden="true"
            />{' '}
            {Intl.NumberFormat('en-IN').format(currentReceivableAmount)}
            <small />
          </h3>
          {showOnAccount && (
            <h4
              className={classes.cardTitle}
              style={{
                fontSize: '16px',
                fontWeight: 500,
                marginTop: '2px',
                marginBottom: '4px',
              }}
            >
              On Account:{' '}
              {hasOnAccountAmount ? (
                <>
                  <i
                    className="fa fa-inr"
                    style={{ fontSize: '16px' }}
                    aria-hidden="true"
                  />{' '}
                  {Intl.NumberFormat('en-IN').format(onAccount)}
                </>
              ) : (
                '--'
              )}
            </h4>
          )}
        </CardHeader>
        <CardBody
          style={{
            marginBottom: '1px',
            paddingBottom: '1px',
            paddingTop: '1px',
          }}
        >
          {this.getTabs()}
        </CardBody>
      </Card>
    );
  }
}

ReceivableHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isDetailedPage: state.transactions.isDetailedPage,
  // currentTransactionData: state.transactions.currentTransactionData,
  transactions: state.transactions.transactions,
  payableTransactions: state.transactions.payableTransactions,
  currentReceivableAmount: state.transactions.currentReceivableAmount,
  activeRole: state.main.activeRole,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      switchActivePage,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(TransactionStyle)(ReceivableHistory));
